import React, {useState, useEffect} from "react";
import {getFields} from "../../../../../dialog/formfields";
import MDBox from "../../../../../../components/MDBox";
import TabPageHeader from "../../header/tabpageheader";
import GenericForm from "../../../../../dialog/genericform";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";

const TransactionPasswordConfig = ({ selectedRowData }) => {
    const [initialData, setInitialData] = useState({});
    const [fields, setFields] = useState([]);
    const api = useConfigApi();
    const { transactionPasswordConfigFields } = getFields();

    const fetchPasswordConfig = async () => {
        try {
            const response = await api.get(Endpoints.passwordConfig.getByControlSlNo(selectedRowData.slNo));
            const data = response?.data?.data || {};
            Object.keys(data).forEach(key => {
                if (data[key] === null || data[key] === undefined) {
                    data[key] = "";
                }
            });
            setInitialData(data);
            let updatedFields = [...transactionPasswordConfigFields];
            if (data.slNo) {
                updatedFields = [
                    {
                        name: "slNo",
                        label: "SL No",
                        readonly: true,
                        value: data.slNo,
                        hidden: true
                    },
                    ...updatedFields,
                ];
            }
            setFields(updatedFields);
        } catch (error) {
            console.error("Failed to fetch terminal config:", error);
            setFields(transactionPasswordConfigFields);
        }
    };

    useEffect(() => {
        fetchPasswordConfig().catch(console.error);
    }, [selectedRowData]);

    const handleValidate = (formData) => {
        delete formData.controlId;
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        console.log("form data", formData);
        if(formData.slNo) {
            api.put(Endpoints.passwordConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Password config successfully created.");
                    fetchPasswordConfig().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        } else {
            api.post(Endpoints.passwordConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Password config successfully updated.");
                    fetchPasswordConfig().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        }

    };

    return (
        <>
            <MDBox
                sx={{
                    px: 3,
                    py: 2,
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <TabPageHeader
                    title="Transaction Password Config"
                    showButton={false}
                />
            </MDBox>
            <MDBox sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                borderBottom: "1px solid #d3e3fd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                {fields.length > 0 && (
                    <GenericForm
                        title="Transaction Password Config"
                        fields={fields}
                        initialData={initialData}
                        useDialog={false}
                        mode="edit"
                        onValidate={handleValidate}
                    />
                )}
            </MDBox>


        </>

    );
};

TransactionPasswordConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default TransactionPasswordConfig;
